import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() business: any; // Replace with the correct type if available
  @Input() LOCATION_IMAGE_PATH: string = '';
  @Input() loggedInUser; // Prashant requirement to remove name and add symbol

  constructor() {
   }

  ngOnInit() {

    console.log("business" , this.business);
    console.log("location_image_path", this.LOCATION_IMAGE_PATH);
    // console.log(this.loggedInUser)
  }

}
